'use strict';

define('animate-modules',['jquery', 'jquery-waypoints', 'jquery-waypoints-sticky'], function ($) {

  var $moduleItem = $('.module__item');

  var initialize = function() {
    $moduleItem.waypoint(function() {
      $(this).addClass('animate');
    }, {
      offset: '85%',
      triggerOnce: true
    });
  };

  return {
    init: initialize
  };

});
